import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { loadPayment, showPayment } from 'Reduxes/consignment/payment/paymentActions'
import TableData from './TableData'
import FormElement from './FormElement'
import Detail from './Detail'

function Payment() {
    const { data, idShow } = useSelector(state => state.paymentReducer)
    // console.log("Payment -> data", data)
    const dispatch = useDispatch()
    const [rowId, setRowId] = useState(null)
    const [content, setContent] = useState('table')

    useEffect(() => {
        dispatch(loadPayment());
    }, [])

    const showTable = () => {
        setContent('table')
    }

    const showDetail = (id) => {
        dispatch(showPayment(id))
        setContent('detail')
    }

    const showForm = (type, id) => {
        setRowId(id)
        setContent('form' + type)
    }

    const renderContent = (contentType) => {
        switch (contentType) {
            case 'table':
                return (<TableData showForm={showForm} showDetail={showDetail} />)
            case 'formNew':
                return (<FormElement type="new" showTable={showTable} />)
            case 'formEdit':
                return (<FormElement type="edit" showTable={showTable} rowId={rowId} />)
            case 'detail':
                return (<Detail showTable={showTable} data={data.filter(singleData => singleData.id === idShow)[0]} />)
            default:
                return <>Nothing to show here</>
        }
    }

    return (
        <>
            {
                renderContent(content)
            }
        </>
    )
}

export default Payment
